// 무한대를 100으로 가정
const INF_NUM = 100

interface ILeisureItemQuantity {
  remains?: number | null
  quantityLimitPerOrder?: number | null
}

const getMaxQuantityOfLeisureItem = (option: ILeisureItemQuantity) => {
  // 재고가 NULL 인 경우에는 관리되지 않는것이므로 무한대로 구입을 할 수 있다
  return Math.min(option.remains ?? INF_NUM, option.quantityLimitPerOrder ?? INF_NUM)
}

export default getMaxQuantityOfLeisureItem
